import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export const Preloader = () => {
  const [done, setDone] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setDone(true), 2200);
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, []);

  useEffect(() => { if (done) document.body.style.overflow = ""; }, [done]);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          data-testid="preloader"
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[hsl(var(--secondary))]"
          initial={{ opacity: 1 }}
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
        >
          <motion.img
            src="/logo.png?v=2"
            alt="Navrang Udaipur"
            className="w-40 h-40 md:w-52 md:h-52 rounded-full object-cover shadow-2xl"
            initial={{ scale: 0.6, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          />
          <motion.div
            className="overflow-hidden mt-8"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.8 }}
          >
            <p className="font-display text-4xl md:text-5xl text-white text-center">Navrang <span className="italic text-[hsl(var(--accent))]">Udaipur</span></p>
            <p className="overline text-white/50 text-center mt-2">Hand Block-Printed Sanganeri Shirts</p>
          </motion.div>
          <motion.div className="mt-10 h-px w-40 bg-white/20 overflow-hidden">
            <motion.div className="h-full bg-[hsl(var(--accent))]" initial={{ width: "0%" }} animate={{ width: "100%" }} transition={{ duration: 2, ease: "easeInOut" }} />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
